<template>
  <div class="actions-buttons">
    <div class="button circular" v-if="hasCircular" @click="showCircular">
      <IconPhoto360 :size="16" />
      <div class="span">360</div>
    </div>
    <div class="button video" v-if="hasVideo" @click="showVideo">
      <IconPlayCircle :size="16" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { IconPhoto360, IconPlayCircle } from '@/features/ui-kit/icons';

interface Props {
  hasCircular?: boolean;
  hasVideo?: boolean;
}

withDefaults(defineProps<Props>(), {
  hasCircular: false,
  hasVideo: false,
});

const emit = defineEmits<{
  showCircular: [];
  showVideo: [];
}>();

function showCircular() {
  emit('showCircular');
}

function showVideo() {
  emit('showVideo');
}
</script>
<style lang="stylus" scoped>
.actions-buttons
  display flex
  column-gap 8px
  .button
    Text(BodyLarge Medium Short)
    background White(A60)
    display flex
    align-items center
    justify-content center
    column-gap 8px
    padding 8px
    backdrop-filter blur(40px)
    -webkit-backdrop-filter blur(40px)
    border-radius 8px
    cursor pointer
    transition all .25s ease-in-out
    &.video
      background hsla(0, 0%, 100%, .6)
    &:hover
      background White(A70)
    &:active
      background White(A80)
</style>
